import Typography from '@mui/material/Typography';

function Logo() {
  return (
    <div className="flex items-center">
      <Typography className="logo-text text-16 leading-none mx-12 font-medium" color="inherit">
        Healthera Connect
      </Typography>
    </div>
  );
}

export default Logo;
